'use client'

import React from 'react'
import { ProductCardGallery } from '../cards'
import {
  GetSearchPhraseProductsQuery,
  GetSearchPhraseProductsQueryVariables,
  SortBy,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GET_SEARCH_PHRASE_PRODUCTS } from '@dustin-web/microsite-data/src/graphql/product/get-search-phrase-products'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { DigitalDataOrigin } from '../utils/digital-data-types'

type Props = {
  searchPhrase: string
  newProductsOnly: boolean
  campaignProductsOnly: boolean
  digitalDataOrigin: DigitalDataOrigin
}

export const SearchPhraseProductList = ({
  searchPhrase,
  newProductsOnly,
  campaignProductsOnly,
  digitalDataOrigin,
}: Props) => {
  const { data } = useGraphql<GetSearchPhraseProductsQuery, GetSearchPhraseProductsQueryVariables>(
    GET_SEARCH_PHRASE_PRODUCTS,
    {
      variables: {
        page: 1,
        pageSize: 4,
        searchPhrase: searchPhrase,
        sortBy: SortBy.Relevance,
        selectedFacets: [
          ...(newProductsOnly ? [{ name: 'isnewproduct', values: ['true'] }] : []),
          ...(campaignProductsOnly ? [{ name: 'campaign', values: ['true'] }] : []),
        ],
      },
    }
  )

  const productReferences = data?.productSearch?.productReferences.slice(0, 4)
  if (!productReferences) {
    return null
  }

  return (
    <div className="container">
      <div className="row sm-gutters">
        {productReferences.map(
          (productReference, i) =>
            productReference.searchResultProduct && (
              <ProductCardGallery
                product={productReference.searchResultProduct}
                ticket={productReference.ticket}
                key={i}
                digitalDataOrigin={digitalDataOrigin}
                digitalIndex={i}
              />
            )
        )}
      </div>
    </div>
  )
}
